import EditQuote from './EditQuote';

export default EditQuote;



// WEBPACK FOOTER //
// ./src/components/forms/EditQuoteForm/index.jsx